import React from "react";
import {
  KelasLiveFeatureBlockContainer,
  KelasLiveFeatureBlockContent,
  KelasLiveFeatureBlockDesc,
  KelasLiveFeatureBlockImageWrapper,
  KelasLiveFeatureBlockSection,
  KelasLiveFeatureBlockTitle,
  KelasLiveFeatureSectionTitle
} from "./kelas-live-feature-block.styles";
import GuruJuaraImage from "public/assets/kelas-live/features/guru-juara.png";
import AmbisImage from "public/assets/kelas-live/features/ambis.png";
import InteractiveImage from "public/assets/kelas-live/features/interactive.png";
import { Container } from "styles/common/container";
import Image from "next/legacy/image";
import { Spacer } from "styles/common/spacer";

const KelasLiveFeatureBlocks: React.FC = () => {
  return (
    <KelasLiveFeatureBlockContainer>
      <Container>
        <KelasLiveFeatureSectionTitle>
          Gurunya ngajarin kayak di kelas, bukan lewat rekaman
        </KelasLiveFeatureSectionTitle>
        <Spacer token={[24, 24, 40]} />
        <KelasLiveFeatureBlockSection flipMedia={true}>
          <KelasLiveFeatureBlockImageWrapper>
            <Image
              src={GuruJuaraImage}
              alt="Guru terbaik yang siap ngajarin murid sampe ngerti"
              layout="responsive"
              sizes="(min-width: 768px) 50vw, 100vw"
              width={1200}
              height={672}
              priority
            />
          </KelasLiveFeatureBlockImageWrapper>
          <KelasLiveFeatureBlockContent>
            <KelasLiveFeatureBlockTitle>
              Guru terbaik yang siap ngajarin murid sampe ngerti
            </KelasLiveFeatureBlockTitle>
            <KelasLiveFeatureBlockDesc>
              Guru Juara ngajarnya asik dan sampe ke materi dasar. Mentor juga
              siap jawab pertanyaanmu.
            </KelasLiveFeatureBlockDesc>
          </KelasLiveFeatureBlockContent>
        </KelasLiveFeatureBlockSection>
        <Spacer token={[24, 24, 24]} />
        <KelasLiveFeatureBlockSection flipMedia={false}>
          <KelasLiveFeatureBlockImageWrapper>
            <Image
              src={AmbisImage}
              alt="Bareng geng ambis, temen sekelas yang saling dukung"
              layout="responsive"
              sizes="(min-width: 768px) 50vw, 100vw"
              width={1200}
              height={672}
              priority
            />
          </KelasLiveFeatureBlockImageWrapper>
          <KelasLiveFeatureBlockContent>
            <KelasLiveFeatureBlockTitle>
              Bareng geng ambis, temen sekelas yang saling dukung
            </KelasLiveFeatureBlockTitle>
            <KelasLiveFeatureBlockDesc>
              Banyak temen, jadi bisa ningkatin mood belajar.
            </KelasLiveFeatureBlockDesc>
          </KelasLiveFeatureBlockContent>
        </KelasLiveFeatureBlockSection>
        <Spacer token={[24, 24, 24]} />
        <KelasLiveFeatureBlockSection flipMedia={true}>
          <KelasLiveFeatureBlockImageWrapper>
            <Image
              src={InteractiveImage}
              alt="Seru, interaktif, nggak bikin bosen"
              layout="responsive"
              sizes="(min-width: 768px) 50vw, 100vw"
              width={1200}
              height={672}
              priority
            />
          </KelasLiveFeatureBlockImageWrapper>
          <KelasLiveFeatureBlockContent>
            <KelasLiveFeatureBlockTitle>
              Seru, interaktif, nggak bikin bosen
            </KelasLiveFeatureBlockTitle>
            <KelasLiveFeatureBlockDesc>
              Nggak cuma belajar, ada kuis asah otak dan Santuy Sejenak — sesi
              games asik ala CoLearn.
            </KelasLiveFeatureBlockDesc>
          </KelasLiveFeatureBlockContent>
        </KelasLiveFeatureBlockSection>
      </Container>
    </KelasLiveFeatureBlockContainer>
  );
};

export { KelasLiveFeatureBlocks };
